<template>
  <div :class="dark ? 'test-dark' : ''" id="app">
    <div style="font-size: 0;"></div>
    <go-top :bottom="70" :right="20" :size="40" :top="300" :type="4" color="#ff8034" />
    <keep-alive :include="['MonthHot']">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import cnzzStat from '@jin10/utils/lib/cnzzStat'
import { mapMutations } from 'vuex'
import GoTop from '@/components/GoTop.vue'
import { getUser } from '@/common/auth'

export default {
  name: 'App',
  data() {
    return {
      dark: false,
      include: ['Week', 'Month']
    }
  },
  methods: {
    ...mapMutations(['SET_ISLOGIN', 'SET_USER', 'SET_APP_THEME'])
  },
  created() {
    const jsBridge = new Jin10JSBridge()
    if (jsBridge.isApp) {
      jsBridge.getAppTheme().then(appTheme => {
        this['SET_APP_THEME'](appTheme)
        this.dark = appTheme == 1 ? true : false
        console.log('dark:', this.dark, appTheme)
      })
    }
    getUser({
      show: true,
      forceUpdate: true
    }).then(user => {
      if (user) {
        console.log(user)
        user.isVip = user.vip_str.length > 0
        this['SET_USER'](user)
        this['SET_ISLOGIN'](true)
      }
    })
  },
  components: {
    GoTop
  }
}
</script>

<style lang="less">
#app {
  /deep/ .v-top {
    z-index: @zIndexGoTop;
  }
  font-family:"Microsoft Yahei";
}
</style>
